import { Platform } from 'quasar'
import { tracker } from 'src/boot/mixpanel'
import useNotificationsStore from 'src/stores/notifications'

function extractNotification(payload) {
  const data = payload.additionalData
  let orderId
  let to

  if (data) {
    orderId = data.order

    const params = { id: orderId }

    if (data.to) {
      to = { name: data.to, params }
    }
    else if (data.url) {
      const url = new URL(data.url)
      const query = {}

      for (const [key, value] of url.searchParams.entries()) {
        query[key] = value
      }

      to = { path: url.pathname, query }
    }
    else if (orderId) {
      to = { name: 'order-detail', params }
    }
  }

  return {
    message: payload.body,
    orderId,
    to,
  }
}

export const oneSignal = {
  initialized: false,

  get instance() {
    return window.plugins && window.plugins.OneSignal
  },

  setup(router) {
    if (process.env.QTM_ENV === 'dev') {
      window.plugins.OneSignal.Debug.setLogLevel(6, 0)
    }

    const oneSignalPlugin = window.plugins.OneSignal
    const notificationsStore = useNotificationsStore()

    oneSignalPlugin.initialize('b3574663-acd1-4031-9b27-ca1be197ad79')
    oneSignalPlugin.Notifications.addEventListener('click', openResult => {
      const notification = extractNotification(openResult.notification)

      notificationsStore.setNotificationAction(openResult.action)

      if (notification.to) {
        router.push(notification.to)
      }

      tracker.track('Notification Opened', {
        rfq_id: notification.orderId || null,
        src: 'push',
        template: notification.to?.query.template || null,
        url: notification.to?.path,
      })
    })

    oneSignalPlugin.Notifications.canRequestPermission().then(canRequest => {
      if (canRequest) {
        oneSignalPlugin.Notifications.requestPermission(true).then(accepted => {
          console.info('Push notifications accepted:', accepted)
        })
      }
    })

    this.initialized = true
  },

  optIn(externalUserId, environment) {
    if (externalUserId) {
      window.plugins.OneSignal.login(`${environment || process.env.QTM_ENV}-${externalUserId}`)
    }
  },

  clearNotifications() {
    window.plugins.OneSignal.Notifications.clearAll()
  },

  async devicePermission() {
    if (!Platform.is.mobile) {
      return false
    }

    return await window.plugins?.OneSignal.Notifications.getPermissionAsync()
  },

  requestPermission() {
    return window.plugins?.OneSignal.Notifications.requestPermission(true)
  },
}

export default async ({ app, router }) => {
  if (Platform.is.nativeMobile) {
    oneSignal.setup(router)
  }

  app.$oneSignal = oneSignal
  app.provide('$oneSignal', oneSignal)
}
